import { Injectable } from '@angular/core';

import { ModuleItemRouting } from '../../../models/module-item-routing';
import { OtherwiseRouteToSpecial, OtherwiseRouteToSpecialIndex } from '../../../models/module-item-routing-group';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  routingData: ModuleItemRouting;
  routingDataChanged = false;

  constructor() {}

  setRoutingData(routingData: ModuleItemRouting): void {
    this.routingData = routingData;
    this.routingDataChanged = true;
  }

  getRoutingData(): ModuleItemRouting {
    return this.prepareRoutingResponse(this.routingData);
  }

  isRoutingDataChanged(): boolean {
    return this.routingDataChanged;
  }

  resetIsRoutingDataChanged(): void {
    this.routingDataChanged = false;
  }

  prepareRoutingResponse(routing): ModuleItemRouting {
    if (routing) {
      routing = JSON.parse(JSON.stringify(routing));
      routing.routingGroups.forEach((group) => {
        if (group.routeToId === OtherwiseRouteToSpecialIndex.NEXT_MODULE) {
          group.routeToSpecial = OtherwiseRouteToSpecial.NEXT_MODULE;
          group.routeToId = null;
        } else if (group.routeToId === OtherwiseRouteToSpecialIndex.END_OF_SURVEY) {
          group.routeToSpecial = OtherwiseRouteToSpecial.END_OF_SURVEY;
          group.routeToId = null;
        } else {
          group.routeToSpecial = '';
        }
      });

      if (routing.otherwiseRouteToId === OtherwiseRouteToSpecialIndex.NEXT_MODULE) {
        routing.otherwiseRouteToSpecial = OtherwiseRouteToSpecial.NEXT_MODULE;
        routing.otherwiseRouteToId = null;
      } else if (routing.otherwiseRouteToId === OtherwiseRouteToSpecialIndex.END_OF_SURVEY) {
        routing.otherwiseRouteToSpecial = OtherwiseRouteToSpecial.END_OF_SURVEY;
        routing.otherwiseRouteToId = null;
      } else {
        routing.otherwiseRouteToSpecial = '';
      }
    }

    return routing;
  }
}
